export const STATUS_AWAITING_APPROVAL = 'awaiting_approval';
export const STATUS_APPROVED = 'approved';
